function cov_6c1253r0w() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/EarlyAccess.tsx";
  var hash = "6c559f3f093cfa0165e035f3ff777b01de295e7c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/EarlyAccess.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6c559f3f093cfa0165e035f3ff777b01de295e7c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_6c1253r0w = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_6c1253r0w();
var Icon = (cov_6c1253r0w().s[0]++, {
  name: 'early-access',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.70016 2.53678C7.5352 2.53678 9.02263 4.0874 9.02263 6H2.37753C2.37753 4.0874 3.86497 2.53678 5.70016 2.53678ZM11.0754 5.32339C11.2539 5.32339 11.4 5.47529 11.4 5.6617C11.4 5.82916 11.2817 5.96921 11.1279 5.99555L11.0754 6H9.85836C9.69771 6 9.56334 5.87669 9.53808 5.71638L9.53381 5.6617L9.53808 5.60693C9.56053 5.46426 9.6692 5.3512 9.8059 5.32783L9.85836 5.32339H11.0754ZM1.54164 5.32339C1.70229 5.32339 1.83666 5.44643 1.86192 5.60693L1.86619 5.6617C1.86619 5.84776 1.72014 6 1.54164 6H0.324555C0.14605 6 0 5.84776 0 5.6617C0 5.47529 0.14605 5.32339 0.324555 5.32339H1.54164ZM10.5281 2.82366C10.6048 2.9683 10.5685 3.1481 10.4499 3.24923L10.4017 3.28325L9.33696 3.89862C9.1982 3.97906 9.02584 3.94109 8.9285 3.81737L8.89573 3.76702L8.87209 3.71115C8.82904 3.57839 8.86975 3.42983 8.97376 3.34108L9.02215 3.30693L10.0868 2.69172C10.243 2.60156 10.4416 2.66093 10.5281 2.82366ZM1.31315 2.69172L2.37785 3.30693C2.51662 3.38707 2.57704 3.55943 2.52789 3.71115L2.50427 3.76702C2.41777 3.92975 2.21915 3.98912 2.06303 3.89862L0.998494 3.28325C0.842383 3.19359 0.785423 2.98638 0.87208 2.82366C0.958574 2.66093 1.15704 2.60156 1.31315 2.69172ZM8.44541 0.781991C8.58014 0.869649 8.63165 1.04512 8.5751 1.19387L8.54878 1.24817L7.90357 2.32398C7.81947 2.46427 7.65113 2.51821 7.50843 2.45921L7.45633 2.43173L7.40979 2.39497C7.3105 2.30063 7.27706 2.15001 7.32649 2.01986L7.3528 1.96555L7.99817 0.889572C8.09278 0.731753 8.29384 0.683375 8.44541 0.781991ZM3.40199 0.889572L4.04704 1.96555C4.13114 2.10583 4.10381 2.28715 3.99036 2.39497L3.94383 2.43173C3.79243 2.53035 3.5912 2.4818 3.49659 2.32398L2.85154 1.24817C2.75693 1.09036 2.80334 0.880607 2.95475 0.781991C3.10615 0.683375 3.30738 0.731753 3.40199 0.889572ZM5.7 0C5.8785 0 6.02455 0.152237 6.02455 0.338305V1.60695C6.02455 1.77441 5.90625 1.91447 5.75246 1.9408L5.7 1.94525C5.52149 1.94525 5.37544 1.79301 5.37544 1.60695V0.338305C5.37544 0.152237 5.52149 0 5.7 0Z\" fill=\"currentColor\"/>"
});
export default Icon;